import { Route, Switch } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_template/helpers";
import { LinkPaymentPay } from "./components/LinkPaymentPay";
import { LinkPaymentStatus } from "./components/LinkPaymentStatus";



export function LinkPaymentPublicPage() {

    return (
        <div
            className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
            style={{
                backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`, height: '100vh',
            }}
        >
            {/* begin::Content */}
            <div className='d-flex text-center flex-column flex-column-fluid p-10 pb-lg-20'>
                {/* begin::Logo */}
                <a href='#' className='mb-12'>
                    <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo-1.png')} className='h-45px' />
                </a>
                {/* end::Logo */}
                {/* begin::Wrapper */}
                <div className='w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>
                    <Switch>
                        <Route path='/public/linkpayment/pay' component={LinkPaymentPay} />
                        <Route path='/public/linkpayment/status' component={LinkPaymentStatus} />
                    </Switch>
                </div>
                {/* end::Wrapper */}
            </div>
            {/* end::Content */}
        </div>
    )
}